import { render, staticRenderFns } from "./fork.vue?vue&type=template&id=67e53a02&scoped=true"
import script from "./fork.vue?vue&type=script&lang=js"
export * from "./fork.vue?vue&type=script&lang=js"
import style0 from "./fork.vue?vue&type=style&index=0&id=67e53a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e53a02",
  null
  
)

export default component.exports